module.exports = __webpack_public_path__ + "img/57.e9494396.jpg";